import { NotificationManager } from 'react-notifications';

import ButtonComponent from '@/components/common-components/ButtonComponent/ButtonComponent';
import TickIcon from '@/components/Icons/icons/TickIcon';

const SignButton = ({ onClick, influencerSignatureMeta }) =>
  influencerSignatureMeta ? (
    <ButtonComponent
      onClick={() => {
        NotificationManager.info('You have already signed the contract');
      }}
      style={{ width: 200 }}
      textStyle={{ fontWeight: '500' }}
      icon={<TickIcon color={'var(--text-success)'} width={24} height={24} />}
      variant="success-outline"
      styles={{ border: '1px solid var(--text-success)' }}>
      Signed
    </ButtonComponent>
  ) : (
    <ButtonComponent onClick={onClick} style={{ width: 200 }}>
      Add Signature
    </ButtonComponent>
  );

export default SignButton;
